import { Alert, Anchor, Box, Flex, List, Title } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { WithApiKey } from '../wrappers/WithApiKey';
import { ApiKeyForm } from '../components/ApiKeyForm';
import { Date } from '../components/Date';

export const EditApiKey = () => {
  const { keyId } = useParams();

  if (!keyId) {
    return <Alert color="red">Missing keyId</Alert>;
  }

  return (
    <Box>
      <Flex justify="space-between">
        <Title order={3} mb={12}>
          Edit API key
        </Title>
        <Anchor href={`/api-keys/${encodeURIComponent(keyId)}/licenses`}>
          View Licenses
        </Anchor>
      </Flex>
      <WithApiKey id={keyId}>
        {(key) => (
          <Box>
            <List listStyleType="none" spacing="md" mb="lg">
              <List.Item>
                <strong>Key:</strong> {key.userKey}
              </List.Item>
              <List.Item>
                <strong>Created on:</strong> <Date isoString={key.createdAt} />
              </List.Item>
              <List.Item>
                <strong>Last updated:</strong>{' '}
                <Date isoString={key.updatedAt} />
              </List.Item>
            </List>
            <ApiKeyForm apiKey={key} />
          </Box>
        )}
      </WithApiKey>
    </Box>
  );
};
